var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 8.99998H17V5H3.1C3.04477 5 3 5.04477 3 5.1V8.89998C3 8.95521 3.04477 8.99998 3.1 8.99998Z",
    stroke: "#8183A2",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.1V16.7585C17 16.8476 17.1077 16.8923 17.1707 16.8293L20.9707 13.0293C20.9895 13.0105 21 12.9851 21 12.9585V5.1C21 5.04477 20.9552 5 20.9 5H17.1C17.0448 5 17 5.04477 17 5.1Z",
    stroke: "#8183A2",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9H7V11.9C7 11.9552 7.04477 12 7.1 12H8.94648C8.97992 12 9.01114 12.0167 9.02969 12.0445L10.8168 14.7252C10.8717 14.8075 11 14.7687 11 14.6697V9Z",
    stroke: "#8183A2",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 5H9.1C9.04477 5 9 4.95523 9 4.9V3.55C9 3.51852 9.01482 3.48889 9.04 3.47L10.84 2.12C10.9059 2.07056 11 2.1176 11 2.2V4.9C11 4.95523 10.9552 5 10.9 5Z",
    stroke: "#8183A2",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7V10",
    stroke: "#8183A2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7V10",
    stroke: "#8183A2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19V21",
    stroke: "#8183A2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19V21",
    stroke: "#8183A2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20H17",
    stroke: "#8183A2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7V9",
    stroke: "#8183A2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8V9",
    stroke: "#8183A2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8V9",
    stroke: "#8183A2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.3b48b69c47c6a5214a7189eee15a6ef5.svg";
export { ForwardRef as ReactComponent };